enum WorldBosses {
  Azuregos,
  Emeriss,
  Lethon,
  LordKazzak,
  Taerar,
  Ysondre
}

export default WorldBosses
